import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  votingId: string;
};

export const adminGetVotingDetail = createQueryFn(
  QueryNameSpace.adminGetVotingDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    if (!params) {
      throw new Error('Provide required parameters!');
    }

    return await DigiobcanApi.adminGetVotingDetail(params.votingId);
  },
);
